export function governance_mounted() {
  if (this.any_modal_open && typeof document !== 'undefined') {
    document.body.classList.add('governance-modal-open');
  }
}

export function governance_before_destroy() {
  if (typeof document !== 'undefined') {
    document.body.classList.remove('governance-modal-open');
  }
}

export const governance_watch = {
  any_modal_open(is_open) {
    if (typeof document === 'undefined') return;
    document.body.classList.toggle('governance-modal-open', is_open);
  }
};
